import { connect } from 'react-redux'
import App from '../../pages/App'
import { getIsLoggedIn, getUserRole } from '../../redux/user/selectors'

const mapStateToProps = (state) => ({
  isLoggedIn: getIsLoggedIn(state),
  userRole: getUserRole(state),
})
export default connect(mapStateToProps, null)(App)
